import React, { FC } from 'react'

import { TableSortableTxt, TableSortType } from 'src/components/molecules'

export type AssignProjectSortItemType = 'project' | 'status' | 'role'

type Props = {
  sortItem: AssignProjectSortItemType
  sortType: TableSortType
  onSelectItem: (newItem: AssignProjectSortItemType) => void
  className?: string
}

export const AssignProjectListHead: FC<Props> = ({
  sortItem,
  sortType,
  onSelectItem,
  className,
}) => {
  return (
    <div className={className}>
      <div className="tw-bg-surface-secondary  tw-p-s-1">
        <div className="tw-flex tw-items-center tw-gap-s0">
          <div className="tw-w-full">
            <TableSortableTxt
              text="Project"
              isActive={sortItem === 'project'}
              sortType={sortType}
              onSelect={() => onSelectItem('project')}
            />
          </div>
          <div className="tw-w-s6 tw-font-bold tw-shrink-0">
            <TableSortableTxt
              text="Status"
              isActive={sortItem === 'status'}
              sortType={sortType}
              onSelect={() => onSelectItem('status')}
            />
          </div>
          <div className="tw-w-[9rem] tw-max-w-[7.9rem] tw-shrink-0">
            <TableSortableTxt
              text="権限"
              isActive={sortItem === 'role'}
              sortType={sortType}
              onSelect={() => onSelectItem('role')}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
